import { Pipe, PipeTransform } from '@angular/core';

export class PolluxDynamicFieldConfig {
  label: string;
  intValue: number;
  decimalValue: number;
  dateValue: Date;
  textValue: string;
  numberFormat: string;
}

@Pipe({
  name: 'rdLocalizedDynamicField'
})
export class RdLocalizedDynamicFieldPipe implements PipeTransform {

  transform(config: PolluxDynamicFieldConfig): string {
    if (!config) return '';

    switch (config.numberFormat) {
      case '0':
        return this.handleInteger(config);
      case '#,##0':
      case '#,##0.00':
      case '0.0000':
        return this.formatNumber(config.decimalValue, config.numberFormat);
      case '$#,##0;$-#,##0':
      case '$#,##0.00;$-#,##0.00':
        return this.formatCurrency(config.decimalValue, config.numberFormat);
      case '0.00':
        return (config.decimalValue * 100).toFixed(2);
      case ' 0%':
      case '0.00%':
        return this.formatPercentage(config.decimalValue, config.numberFormat);
      case 'm/d/yyyy':
      case 'd-mmm-yy':
      case 'd-mmm':
      case 'mmm-yy':
      case 'h:mm AM/PM':
      case 'h:mm:ss AM/PM':
      case 'h:mm':
      case 'h:mm:ss':
      case 'm/d/yy h:mm':
      case 'mm:ss':
      case 'h :mm:ss':
      case 'mm:ss.0':
        return config.dateValue ? config.dateValue.toLocaleDateString('rd-RD') : '';
      case '# ?/?':
      case '# /':
      case '_ * #,##0_ ;_ * “_ ;_ @_':
      case '_ $* #,##0_ ;_ $* “_ ;_ @_':
      case '_ * #,##0.00_ ;_ * “??_ ;_ @_':
      case '_ $* #,##0.00_ ;_ $* “??_ ;_ @_':
      case '##0.0E+00':
      case '@':
        return config.textValue ? config.textValue : '';
      case 'General':
      case null:
        return this.getFirstNonNullValue(config);
      default: {
        //console.warn("Unsupported number format: " + config.numberFormat);
        return config.textValue;
      }
    }
  }

  private handleInteger(config: PolluxDynamicFieldConfig): string {
    if (config.intValue !== null && config.intValue !== undefined) {
      return config.intValue.toString();
    }
    return '';
  }

  private formatNumber(value: number, format: string): string {
    if (value !== null && value !== undefined) {
      return value.toFixed(format === '#,##0' ? 0 : 2);
    }
    return '';
  }

  private formatCurrency(value: number, format: string): string {
    if (value !== null && value !== undefined) {
      return value.toFixed(2);
    }
    return '';
  }

  private formatPercentage(value: number, format: string): string {
    if (value !== null && value !== undefined) {
      return (value * 100).toFixed(format === ' 0%' ? 0 : 2) + '%';
    }
    return '';
  }

  private getFirstNonNullValue(config: PolluxDynamicFieldConfig): string {
    if (config.intValue !== null && config.intValue !== undefined) {
      return config.intValue.toString();
    }
    if (config.decimalValue !== null && config.decimalValue !== undefined) {
      return config.decimalValue.toFixed(2);
    }
    if (config.dateValue) {
      return config.dateValue.toLocaleDateString('rd-RD');
    }
    if (config.textValue) {
      return config.textValue;
    }
    return '';
  }
}
